import {Button, Grid, TextField} from "@material-ui/core";
import React, {useEffect, useState} from "react";
import useRegisterExit from "../../../hooks/useRegisterExit";
import { useTranslation } from "../../../hooks/useTranslation";
import { useStyles } from "./RegisterExitSearchStyles";
import { useDelayedState } from "../../../hooks/useDelayedState";
import {
  setPaginationPage,
  setSearchValue,
} from "../../../redux/actions/registerExitActions";
import { useDispatch } from "react-redux";
import {useLocation} from "react-router-dom";

const RegisterExitSearch = () => {
  const classes = useStyles();
  const { t, BundleKey } = useTranslation();
  const { fetchPeopleInside } = useRegisterExit();
  const dispatch = useDispatch();
  const [firstRender, setFirstRender] = useState(true);
  const location = useLocation();

  const { state: searchValue, setState: setSearchValueDelayed } =
      useDelayedState<string>("", (newSearchValue) => {
        if (firstRender) {
          setFirstRender(false);
        } else {
          dispatch(setSearchValue(newSearchValue));
          fetchPeopleInside(0, newSearchValue);
          dispatch(setPaginationPage(0));
        }
      });

    useEffect(() => {
        fetchPeopleInside(0, "");
        setSearchValueDelayed("");
    }, [location]);

    const handleSearch = () => {
        fetchPeopleInside(0, searchValue);
        dispatch(setPaginationPage(0));
    }


  return (
      <Grid container spacing={1} alignItems='center'>
          <Grid item xs={9}>
              <TextField
                  className={classes.search}
                  value={searchValue}
                  id="search-pending-request"
                  label={t(BundleKey.REGISTEREXIT_SEARCH_PLACEHOLDER)}
                  variant="outlined"
                  onChange={(e) => setSearchValueDelayed(e.target.value)}
                  fullWidth
                  autoFocus
                  onKeyPress={(e) => {
                      if (e.key === 'Enter') {
                          handleSearch();
                      }
                  }}
              />
          </Grid>
          <Grid item xs={3} style={{height: '75%'}}>
              <Button
                  onClick={handleSearch}
                  color="primary"
                  variant="contained"
                  fullWidth
                  style={{height: '100%'}}
              >
                  {t(BundleKey.PENDINGREQUEST_SEARCH_PLACEHOLDER)}
              </Button>
          </Grid>
      </Grid>
  );
};

export default RegisterExitSearch;
